import { render, staticRenderFns } from "./projectHeader.vue?vue&type=template&id=7ce2f78d&scoped=true"
import script from "./projectHeader.vue?vue&type=script&lang=js"
export * from "./projectHeader.vue?vue&type=script&lang=js"
import style0 from "./projectHeader.vue?vue&type=style&index=0&id=7ce2f78d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce2f78d",
  null
  
)

export default component.exports